export default "__VITE_ASSET__Z0Xa8jl9__"